import { useLocalization } from '@/contexts/LocalizationContext'

export function VerifyOTPPage() {
  const { t } = useLocalization()
  return (
    <div className="container mx-auto px-4 py-4 sm:py-6">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">{t('auth.verifyOtp')}</h1>
      <p className="text-sm sm:text-base text-muted-foreground">{t('auth.otpVerificationMessage')}</p>
    </div>
  )
}
